import Footer from '../base/footer';
import returnToTop from '../base/returnToTop';
import baidu from '../base/baidu';
import { registerProductPage, initTabs } from '../base/product2026';

registerProductPage('数据标注服务', 21);
initTabs('[data-pd2026-tabs="annotation"]');
